<template>
  <div class="meal-manage-page">
    <van-tabs :sticky="true" v-model="active">
      <van-tab title="订餐" name="menu" :to="{ name: 'mealMenu' }" />
      <van-tab title="领餐" name="order" :to="{ name: 'mealOrder' }" />
      <van-tab
        v-if="!commentDisabled"
        title="评价"
        name="comment"
        :to="{ name: 'mealComment' }"
      />
    </van-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabs, Tab } from 'vant';

// 一次性引入常用组件
[Tabs, Tab].forEach(item => {
  if (item.install) {
    Vue.use(item);
  }
});

export default {
  data() {
    return {
      commentDisabled: true, // 评论是否在允许的时间
      active: 'menu',
    };
  },
  provide() {
    return {
      setActive: val => {
        this.active = val;
      },
    };
  },
  created() {
    this.setDisabled();
    this.timer = setInterval(() => {
      this.setDisabled();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    /**
     * 评价功能只在17:30～20:00可用
     */
    setDisabled() {
      const timeRange = [17 * 60 + 30, 20 * 60];
      this.commentDisabled = !this.$utils.hasInTimeRange(timeRange);
    },
  },
};
</script>

<style lang="scss">
.meal-manage-page {
  .van-tab {
    font-size: 16px;
  }
}
.meal-tab-page {
  margin-top: 60px;
  padding-bottom: 100px;
  .van-notice-bar {
    position: relative;
    top: -10px;
  }
}
</style>
